'use client';
import { useEffect, useState } from 'react';
import { Bot, MessageSquare, Target, Zap, Rocket } from 'lucide-react';
import styles from './GlobalParallax.module.css';

export function GlobalParallax() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setScrollY(window.scrollY);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    // O wrapper agora tem perspectiva para habilitar a profundidade 3D
    <div className={styles.parallaxWrapper} style={{ perspective: '1200px' }}>
      
      {/* Aproxima lentamente da tela ao descer (Scale aumenta, Z positivo) */}
      <div className={`${styles.parallaxIcon} ${styles.icon1}`} 
           style={{ transform: `translate3d(0, ${scrollY * -0.15}px, ${scrollY * 0.05}px) rotate(${scrollY * 0.05}deg) scale(${1 + scrollY * 0.0002})` }}>
        <Bot size={250} />
      </div>
      
      {/* Vem rápido para cima e para a frente (Sensação de vulto passando perto) */}
      <div className={`${styles.parallaxIcon} ${styles.icon2}`} 
           style={{ transform: `translate3d(0, ${scrollY * -0.3}px, ${scrollY * 0.15}px) rotate(${scrollY * -0.02}deg) scale(${1 + scrollY * 0.0004})` }}>
        <MessageSquare size={180} />
      </div>

      {/* Afunda para o fundo da tela (Scale diminui, Z negativo) */}
      <div className={`${styles.parallaxIcon} ${styles.icon3}`} 
           style={{ transform: `translate3d(0, ${scrollY * 0.1}px, ${scrollY * -0.1}px) rotate(${scrollY * 0.04}deg) scale(${1 - scrollY * 0.0001})` }}>
        <Target size={300} />
      </div>

      {/* Rápido, giratório e se aproxima */}
      <div className={`${styles.parallaxIcon} ${styles.icon4}`} 
           style={{ transform: `translate3d(0, ${scrollY * -0.25}px, ${scrollY * 0.1}px) rotate(${scrollY * -0.06}deg) scale(${1 + scrollY * 0.00025})` }}>
        <Zap size={200} />
      </div>

      {/* Lento e distante */}
      <div className={`${styles.parallaxIcon} ${styles.icon5}`} 
           style={{ transform: `translate3d(0, ${scrollY * -0.12}px, 0) rotate(${scrollY * 0.03}deg)` }}>
        <Rocket size={220} />
      </div>
    </div>
  );
}